module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', {
    staticClass: "basic-card w-100 min-h-auto"
  }, [_c('div', {
    staticClass: "mdl-card__section basic-card-header"
  }, [_c('div', {
    staticClass: "mdl-typography--body-1 typography--font-weight-600 typography--color-primary"
  }, [_vm._v("\n      " + _vm._s(_vm.headerTitle) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__section basic-card-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__section basic-card-footer"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc86228","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicCard.vue
// module id = 1558
// module chunks = 1